const enum MimicTypos {
    "NEVER" = "NEVER",
    "SOMETIMES" = "SOMETIMES",
    "OFTEN" = "OFTEN"
}

export default MimicTypos;